import Layout from '../views/layout/Layout'
import { generateConfigRoute } from '@com/utils/generateConfigRoute'

export default {
  path: '/butler',
  component: Layout,
  redirect: 'noredirect',
  name: 'butler',
  meta: {
    title: '素材提需管理',
    elicon: 'el-icon-document',
    roles: [],
  },
  children: [
    {
      path: 'submitted-demand',
      name: 'butler.submitted-demand',
      redirect: 'submitted-demand/index',
      component: () => import('@/views/butler/submittedDemand/index'),
      meta: {
        title: '提交需求',
        roles: ['demand.demand.statistic'],
      },
      hiddenChildren: true,
      children: [
        {
          path: 'index',
          component: () => import('@/views/butler/submittedDemand/dashboard'),
          meta: {
            title: '首页',
            roles: ['demand.demand.statistic'],
          },
        },
        {
          path: 'demand',
          name: 'butler.submitted-demand.demand',
          component: () => import('@/views/butler/submittedDemand/demand'),
          meta: {
            title: '需求管理',
            roles: ['demand.demand.statistic'],
          },
        },
        {
          path: 'task',
          component: () => import('@/views/butler/submittedDemand/task'),
          meta: {
            title: '任务管理',
            roles: ['demand.demand.statistic'],
          },
        },
      ],
    },

    // 分配需求
    {
      path: 'assigned-demand',
      name: 'butler.assigned-demand',
      redirect: 'assigned-demand/index',
      component: () => import('@/views/butler/assignedDemand/index'),
      meta: {
        title: '分配需求',
        roles: ['demand.demand.assign-statistic'],
      },
      hiddenChildren: true,
      children: [
        {
          path: 'index',
          name: 'butler.assigned-demand',
          component: () => import('@/views/butler/assignedDemand/dashboard'),
          meta: {
            title: '首页',
            roles: ['demand.demand.assign-statistic'],
          },
        },
        {
          path: 'demand',
          name: 'butler.assigned-demand.demand',
          component: () => import('@/views/butler/assignedDemand/demand'),
          meta: {
            title: '需求管理',
            roles: ['demand.demand.assign-statistic'],
          },
        },
        {
          path: 'task',
          name: 'butler.assigned-demand.task',
          component: () => import('@/views/butler/assignedDemand/task'),
          meta: {
            title: '任务管理',
            roles: ['demand.demand.assign-statistic'],
          },
        },
      ],
    },

    // 需求列表
    {
      path: 'demand-list',
      name: 'butler.demand-list',
      component: () => import('@/views/butler/demand-list/index'),
      meta: {
        title: '需求列表',
        roles: ['demand.demand.list-all'],
      },
    },

    // 任务列表
    {
      path: 'task-list',
      name: 'butler.task-list',
      component: () => import('@/views/butler/task-list/index'),
      meta: {
        title: '任务列表',
        roles: ['qa.task.list-all'],
      },
    },

    // 工单管理
    {
      path: 'work-order',
      name: 'butler.work-order',
      component: () => import('@/views/butler/work-order/index'),
      meta: {
        title: '工单管理',
        roles: ['demand.order.list'],
      },
    },

    // 需求详情
    {
      path: 'demand-detail/:id(\\d+)',
      name: 'butler.demand-detail',
      component: () => import('@/views/demand/detail/index'),
      meta: {
        title: '需求详情',
        roles: ['demand.demand.info'],
      },
      hidden: true,
    },

    // 创建需求
    {
      path: 'create-demand',
      name: 'butler.create-demand',
      component: () => import('@/views/demand/create/index'),
      meta: {
        title: '创建需求',
        roles: ['demand.demand.create'],
      },
      hidden: true,
    },

    // 编辑需求
    {
      path: 'edit-demand/:id(\\d+)',
      name: 'butler.edit-demand',
      component: () => import('@/views/demand/create/index'),
      meta: {
        title: '编辑需求',
        roles: ['demand.demand.update'],
      },
      hidden: true,
    },

    // 需求交付
    {
      path: 'deliver-demand/:id(\\d+)',
      name: 'butler.deliver-demand',
      component: () => import('@/views/demand/deliver-demand/index'),
      meta: {
        title: '需求交付',
        roles: ['demand.demand.deliver'],
      },
      hidden: true,
    },

    // 配置策划案
    {
      path: 'configuration-scheme/:id(\\d+)',
      name: 'butler.configuration-scheme',
      component: () => import('@/views/demand/configuration-scheme/index'),
      meta: {
        title: '配置策划案',
        roles: ['demand.interactive.configure'],
      },
      hidden: true,
    },

    // 提交任务
    {
      path: 'submit-task/:id(\\d+)',
      name: 'butler.submit-task',
      component: () => import('@/views/demand/submit-task/index'),
      meta: {
        title: '提交任务',
        roles: ['demand.interactive.deliver'],
      },
      hidden: true,
    },

    // ps 素材管理
    {
      path: 'ps',
      name: 'butler.ps',
      component: () => import('@/views/butler/playsmart-management/index.vue'),
      meta: {
        title: 'playsmart素材管理',
        roles: ['ps.project.list'],
      },
    },

    // 素材审核
    {
      path: 'review',
      name: 'butler.review',
      component: () => import('@/views/butler/review/index.vue'),
      meta: {
        title: '素材审核',
        roles: ['creative.review.list'],
      },
    },
    {
      path: 'report',
      name: 'butler.report',
      redirect: 'report/auth',
      component: () => import('@/views/butler/report/index.vue'),
      meta: {
        title: '素材审核管理',
        roles: [],
      },
      hiddenChildren: true,
      children: [
        {
          path: 'auth',
          name: 'butler.report.auth',
          component: () => import('@/views/butler/report/auth.vue'),
          meta: {
            title: '广告审核报表',
            roles: ['creative.report.list'],
          },
        },
        {
          path: 'plan',
          name: 'butler.report.plan',
          component: () => import('@/views/butler/report/plan.vue'),
          meta: {
            title: '高风险广告主列表',
            roles: ['creative.warning.warning-list'],
          },
        },
        {
          path: 'whitelist',
          name: 'butler.report.whitelist',
          component: () => import('@/views/butler/report/whitelist.vue'),
          meta: {
            title: '白名单广告主列表',
            roles: ['creative.whitelist.list'],
          },
        },
        {
          path: 'product',
          name: 'butler.report.product',
          component: () => import('@/views/butler/report/product.vue'),
          meta: {
            title: '高风险产品标签列表',
            // 角色是什么
            roles: ['creative.warning.list'],
          },
        },
        {
          path: 'history',
          name: 'butler.report.history',
          component: () => import('@/views/butler/report/history.vue'),
          meta: {
            title: '巡审计划历史',
            roles: ['creative.plan.log-list'],
          },
        },
      ],
    },
    {
      path: 'creative-direction',
      name: 'butler.creative-direction',
      component: () => import('@/views/butler/creative-direction/list/index'),
      meta: {
        title: '创意方向列表',
        roles: ['dmaker.info.list'],
      },
    },
    {
      path: 'creative-direction-management',
      name: 'butler.creative-direction-management',
      component: () => import('@/views/butler/creative-direction/manager'),
      meta: {
        title: '创意方向管理',
        roles: ['dmaker.info.template-list'],
      },
    },

    // 创意标签管理
    {
      path: 'creative-tag-manage',
      name: 'butler.creative-tag-manage',
      to: {
        query: {
          tag_type: 'noninteractive-tag',
        },
      },
      component: () => import('@/views/butler/creativeTag/index'),
      meta: {
        title: '创意标签管理',
        roles: ['system.app-tag.list'],
      },
    },

    {
      path: 'creative-list',
      name: 'butler.creative-list',
      component: () => import('@/views/butler/creative-list/index'),
      meta: {
        title: '创意列表',
        roles: ['demand.creation.list'],
      },
    },
    {
      path: 'custom-list',
      name: 'butler.custom-list',
      component: () => import('@/views/creative/custom-list/index'),
      redirect: 'custom-list/manage/1',
      meta: {
        title: '动态参数版本制作列表',
        roles: ['dmaker.custom-dist.list'],
      },
      hiddenChildren: true,
      children: [
        {
          path: 'manage/:type(\\d+)',
          name: 'butler.custom-list.manage',
          component: () => import('@/views/creative/custom-list/list'),
          meta: {
            title: '制作列表',
            roles: ['dmaker.custom-dist.list'],
          },
        },
      ],
    },

    // {
    //   path: 'invoice-management',
    //   name: 'butler.invoice-management',
    //   component: () => import('@/views/butler/invoice-management/index'),
    //   meta: {
    //     title: '账单推送管理',
    //     roles: ['finance.bill.list'],
    //   },
    // },

    generateConfigRoute(
      {
        title: '账单推送管理',
        pageId: 'bill-manage',
        isRootRoute: false,
      },
      {
        routeConfig: {
          component: Layout,
          // hidden: true,
        },
        metaConfig: {
          title: '账单推送管理',
          roles: ['finance.bill.list'],
          icon: '',
        },
      },
    ),

    {
      path: 'tunnel',
      name: 'butler.tunnel',
      component: () => import('@/views/butler/tunnel/index'),
      meta: {
        title: '一键调整归属',
        roles: ['qa.task.adjust-owner', 'demand.demand.adjust-owner'],
      },
      to: {
        query: {
          role_type: 2,
          transform_type: 1,
        },
      },
    },
  ],
}
